"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23,17.69V15.53A3.55,3.55,0,0,0,19.45,12h-6.9A3.55,3.55,0,0,0,9,15.53v2.16a3.55,3.55,0,0,0,3.55,3.55H13V23a.39.39,0,0,0,.67.28l3-2.05h2.79A3.55,3.55,0,0,0,23,17.69Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8,17.69V15.53A4.55,4.55,0,0,1,12.55,11h3.77A9.51,9.51,0,0,0,17,8,8,8,0,0,0,1,8c0,4.24,7.27,15.31,7.58,15.78A.52.52,0,0,0,9,24a.54.54,0,0,0,.42-.22c.07-.12.55-.85,1.24-2A4.53,4.53,0,0,1,8,17.69ZM5.5,8A3.5,3.5,0,1,1,9,11.48,3.5,3.5,0,0,1,5.5,8Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;